import { render, staticRenderFns } from "./addRetail.vue?vue&type=template&id=39442022&scoped=true&"
import script from "./addRetail.vue?vue&type=script&lang=js&"
export * from "./addRetail.vue?vue&type=script&lang=js&"
import style0 from "./addRetail.vue?vue&type=style&index=0&id=39442022&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39442022",
  null
  
)

export default component.exports